
import { Stack } from 'ui/stack';

import Modal from 'components/partials/modal/modal';
import Button from 'components/partials/button/button';

interface UnsavedChangesModalProps {
  open: boolean;
  loading?: boolean;
  onSaveAndContinue: () => void;
  onDiscardAndContinue: () => void;
  onClose: () => void;
}

const UnsavedChangesModal = ({
  open,
  loading = false,
  onSaveAndContinue,
  onDiscardAndContinue,
  onClose,
}: UnsavedChangesModalProps) => {
  if (!open) return null;

  return (
    <Modal
      headerText="You have unsaved changes"
      headerSubtext="Save your changes to continue."
      onCloseCallback={onClose}
      showCloseButton
      disableBackdropClick
      skipUnmountOnClose
      modalClassName="!w-[452px]"
      primaryAction={{ onClick: onSaveAndContinue, loading }}
      footer={
        <Stack direction="row" sx={{ alignItems: 'center', gap: 2 }}>
          <Button
            type="button"
            variant="brand-filled"
            size="md"
            loading={loading}
            onClick={onSaveAndContinue}
            data-testid="save-and-continue-button"
          >
            Save & Continue
          </Button>
          <Button
            type="button"
            variant="reserve-text"
            size="md"
            onClick={onDiscardAndContinue}
            data-testid="discard-and-continue-button"
          >
            Discard & Continue
          </Button>
        </Stack>
      }
      data-testid="unsaved-changes-modal"
    />
  );
};

export default UnsavedChangesModal;
